<div class="container flex-container">
      <div class="panel-content">
        <form [formGroup]="contactInfoForm" *ngIf="contactInfoForm">
          <div class="input-section input-row">
            <mat-form-field class="inputField" appearance="outline">
              <mat-label>Contact Title</mat-label>
              <input
                matInput
                placeholder="Contact Title"
                required
                pattern="(.|\s)*\S(.|\s)*"
                maxlength="10"
                formControlName="contactTitle"
                [readonly]="false"
              />
              <mat-error *ngIf="contactInfoForm.get('contactTitle')?.hasError('required') && contactInfoForm.get('contactTitle')?.touched">
                <em class="error-hint"> Required</em>
              </mat-error>
            </mat-form-field>

            <mat-form-field class="inputField" appearance="outline">
              <mat-label>Contact Name</mat-label>
              <input
                matInput
                placeholder="Contact Name"
                required
                pattern="(.|\s)*\S(.|\s)*"
                maxlength="100"
                formControlName="contactName"
                [readonly]="false"
              />
              <mat-error *ngIf="contactInfoForm.get('contactName')?.hasError('required') && contactInfoForm.get('contactName')?.touched">
                <em class="error-hint"> Required</em>
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Email</mat-label>
              <input
                matInput
                placeholder="Email"
                required
                pattern="(.|\s)*\S(.|\s)*"
                maxlength="150"
                formControlName="email"
                [readonly]="false"
              />
              <a matSuffix mat-icon-button [href]="emailString">
                <mat-icon>email</mat-icon>
              </a>
              <mat-error *ngIf="contactInfoForm.get('email')?.hasError('required') && contactInfoForm.get('email')?.touched">
                <em class="error-hint"> Required</em>
              </mat-error>
            </mat-form-field>
          </div>

          <div class="input-section input-row">
            <mat-form-field appearance="outline">
              <mat-label>Address Line 1</mat-label>
              <input
                matInput
                placeholder="Address Line 1"
                required
                pattern="(.|\s)*\S(.|\s)*"
                maxlength="100"
                formControlName="address1"
                [readonly]="false"
              />
              <mat-error><em class="error-hint"> Required</em> </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Address Line 2</mat-label>
              <input
                matInput
                placeholder="Address Line 2"
                maxlength="100"
                formControlName="address2"
                [readonly]="false"
              />
              <mat-error><em class="error-hint"> Required</em> </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>City</mat-label>
              <input
                matInput
                placeholder="city"
                required
                pattern="(.|\s)*\S(.|\s)*"
                formControlName="city"
                [readonly]="false"
              />
              <mat-error><em class="error-hint"> Required</em> </mat-error>
            </mat-form-field>
          </div>

          <div class="input-section input-row">
            <mat-form-field appearance="outline">
              <mat-label>Postal Code</mat-label>
              <input
                matInput
                placeholder="Postal Code"
                required
                pattern="(.|\s)*\S(.|\s)*"
                formControlName="postalCode"
                [readonly]="false"
              />
              <mat-error><em class="error-hint"> Required</em> </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>State</mat-label>
              <input
                matInput
                placeholder="State"
                required
                pattern="(.|\s)*\S(.|\s)*"
                formControlName="state"
                [readonly]="false"
              />
              <!-- <input matInput placeholder="State" required pattern="(.|\s)*\S(.|\s)*" formControlName="state"> -->
              <!-- <mat-error><em class="error-hint"> Required</em> </mat-error> -->
            </mat-form-field>

             <mat-form-field appearance="outline">
              <mat-label>Country</mat-label>
              <mat-select name="Country" formControlName="country" required>
                <mat-option
                  *ngFor="let country of countryList"
                  [value]="country.Code"
                >
                  {{ country.Name }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="contactInfoForm.get('country')?.hasError('required')"
              >
                <em class="error-hint">Country is required</em>
              </mat-error>
            </mat-form-field> 
          </div>

          <div class="input-section input-row">
            <mat-form-field appearance="outline">
              <mat-label>Phone Number (Legacy)</mat-label>
              <input
                matInput
                placeholder="Phone Number"
                formControlName="phoneOld"
                [readonly]="false"
              />
              <mat-hint><em> Read only</em> </mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Phone Country Code</mat-label>
              <input
                matInput
                placeholder="Phone Country Code"
                required
                pattern="(.|\s)*\S(.|\s)*"
                formControlName="phoneCountryCode"
                [readonly]="false"
              />
              <mat-error><em class="error-hint"> Required</em> </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Phone Number</mat-label>
              <input
                matInput
                placeholder="Phone Number"
                required
                pattern="(.|\s)*\S(.|\s)*"
                formControlName="phone"
                [readonly]="false"
              />
              <mat-error><em class="error-hint"> Required</em> </mat-error>
            </mat-form-field>
          </div>

          <div class="button-section">
            <button
              mat-flat-button
              class="seneca-button"
              color="primary"
              (click)="update()"
              [disabled]="!contactInfoForm.valid"
            >
              Update
            </button>

            <!-- <button
              mat-flat-button
              *ngIf="pendingMode"
              class="seneca-button seneca-stroke-button"
              type="button"
              color="primary"
              (click)="onApprove()"
              [disabled]="!contactInfoForm.valid"
            >
              Approve
            </button>  -->
          </div>

          <div class="save-message" *ngIf="saved">
            <strong>Changes Saved</strong>
          </div>

          <div class="error-message" *ngIf="error">
            <strong>Error Saving Changes</strong>
          </div>
        </form>
      </div>
    </div>